module.exports = __webpack_public_path__ + "static/media/real-estate.1af22f25.jpg";